/**
 * SSR-safe HTML → plain text.
 *
 * BYOD table cells (notably entity-attribute values like a parsed-resume
 * `candidate/description`) can carry rich HTML. Rendering it verbatim shows raw
 * `<div…>` markup as escaped text; this strips tags + decodes the common named
 * entities so the cell shows readable text instead.
 *
 * Unlike `stripHtml` in src/utils (which builds a `<div>` via `document` and so
 * can't run during SSR), this is pure string work and safe at render time.
 * Strings with no HTML tag are returned unchanged, so non-HTML cells are
 * untouched.
 */

const HTML_TAG_RE = /<\/?[a-z][\s\S]*?>/i;

export function htmlToPlainText(value: string): string {
  if (!HTML_TAG_RE.test(value)) {
    return value;
  }
  return value
    .replace(/<(script|style)[\s\S]*?<\/\1>/gi, ' ') // drop script/style bodies
    .replace(/<[^>]+>/g, ' ') // strip remaining tags
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0*39;|&#x0*27;|&apos;/gi, '\'')
    .replace(/&amp;/gi, '&') // decode last so "&amp;lt;" doesn't become "<"
    .replace(/\s+/g, ' ')
    .trim();
}
